const mergeSx=(...b)=>{const c=[];for(const d of b)if(d)if(Array.isArray(d))for(const e of d)c.push(e);else c.push(d);return c};export {mergeSx};